import Action from '../Action'
import './ModalCreateException.css'
import { useState ,useEffect} from 'react';
import LoadSimple from '../LoadSimple';
import { useFetch } from '../../hooks/useFetch';
import SelectorAdmin from '../SelectorAdmin';
// import SelectorIcons from '../SelectorIcons';
import Select from 'react-select'
import { capitalizeFirstLetter } from '../../utils/utils';
import { lang } from '../generales/traduction';

const ModalResponseEncuesta =({handleShowPopup,languaje,mode,server,closCreateCisModal,suveryId})=>{
  const obtenerFechaActualLocal = () => {
      const ahora = new Date();
      const anio = ahora.getFullYear();
      const mes = String(ahora.getMonth() + 1).padStart(2, '0'); // El mes se cuenta desde 0
      const dia = String(ahora.getDate()).padStart(2, '0');
      const horas = String(ahora.getHours()).padStart(2, '0');
      const minutos = String(ahora.getMinutes()).padStart(2, '0');
    
      return `${anio}-${mes}-${dia}T${horas}:${minutos}`;
    };
  //   console.log(groupSelected)
  useEffect(()=>{
    
      buscar_encuesta(suveryId)
      buscar_encuesta_info(suveryId)
  },[])

  const [loadingM,setLoadingM]=useState(false);
  const [IpValid,setIpValid]=useState(true)
  const [matchPassword,setMatchPassword]=useState(false)
  const [disabled,setDisabled]=useState(true)
  const [host,sethost]=useState([])
  const [ManttoData,setManttoData]=useState({
      // name_brand:(editActive)?groupSelected.name_brand:"",
          code: "",
          title: "",
          description:"",
          trigger_id:null,
          period_id:null,
        
      })
  const [OptionsData,setOptionsData]=useState([{
          survey_id: 1,
          question_text: "",
          type: "Texto",
          options: []
          }])

  const [answareData,setAnswareData]=useState([{
   "question_text":"",
   "question_id": 0,
   "answer": "string"
 }])
  useEffect(() => {
    const updatedAnswareData = OptionsData.map(pregunta => ({
      question_text:pregunta.question_text,
      question_id: pregunta.id,
      answer: ""
    }));
    setAnswareData(updatedAnswareData);
  }, [OptionsData]);
  const [hostName,setHostName]=useState("")
  const [hostLocation,setHostLocation]=useState("")
  const [hostActivate,setHostActivate]=useState(0)
  // const tec_list=useFetch('cassia/ci_elements/technologies','','','GET',server)
  const [msgError,setMsgError]=useState("")
  const [listSearchIP,setListSearchIP]=useState(false)


  const handleChange=(e)=>{
      // console.log(e.target.name)
      const {name,value}=e.target
      if(e.target.name==="criticality"){
          setManttoData((prevState)=>{
              return {
                  ...prevState,
                  [name]:value===""?0:(parseInt(value))
              }
              
          })
      }  else if(e.target.name==="status"){
          setManttoData((prevState)=>{
              return {
                  ...prevState,
                  [name]:(value=="Inactivo")?"Activo":"Inactivo"
              }
              
          })
      }else{
          setManttoData((prevState)=>{
              return {
                  ...prevState,
                  [name]:value
              }
              
          })
      }
          
        
     
      if(e.target.name==="ip"){
          if(value==""){
              setHostLocation("")
              setHostActivate(0)
              setIpValid(true)
              sethost([])
              setHostName("")
              setHostLocation("")
          }else{
              
          }
         
         
        }

      
      
    }

  useEffect(()=>{
   
        if( ManttoData.name_brand=="" || ManttoData.mac_address_brand_OUI=="" ){
            // console.log('disabled')
            setDisabled(true)
        }else{
            // console.log('no disabled')
            setDisabled(false)
        }
  },[ManttoData])
  const [loadingEncuesta,setLoadingEncuesta]=useState(false)
  const [dataTest,setDataTest]=useState([])
  const buscar_encuesta_info = (suvery_id) => {
    setLoadingEncuesta(true)
    const fetchDataPost = async () => {
      try {
        
        const response = await fetch(
          server.url +
            "/api/v1/cassia/surveys/_surveys/"+suvery_id,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              accept: "application/json",
              Authorization: `Bearer ${localStorage.getItem("access_token")}`,
            },
          }
        );
        // console.log(response);
        if (response.ok) {
          const data1 = await response.json();
          setLoadingEncuesta(false)
          setManttoData(data1.data)
          setDataTest(data1);
          // setCreateCisModalOpen(true)
        } else {
          const data1 = await response.json();
          throw new Error("Error en la solicitud");
        }
      } catch (error) {
        console.error(error);
      }
    };

    fetchDataPost();
  };
  const buscar_encuesta = (suvery_id) => {
    setLoadingEncuesta(true)
    const fetchDataPost = async () => {
      try {
        
        const response = await fetch(
          server.url +
            "/api/v1/cassia/surveys/_surveys/"+suvery_id+"/questions/",
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              accept: "application/json",
              Authorization: `Bearer ${localStorage.getItem("access_token")}`,
            },
          }
        );
        // console.log(response);
        if (response.ok) {
          const data1 = await response.json();
          setLoadingEncuesta(false)
          setOptionsData(data1.message)
          setDataTest(data1);
          // setCreateCisModalOpen(true)
        } else {
          const data1 = await response.json();
          throw new Error("Error en la solicitud");
        }
      } catch (error) {
        console.error(error);
      }
    };

    fetchDataPost();
  };
  const RegistrarEncuesta=()=>{
    
    let method='POST'
    let url_add=''
    
    let  body ={
      "survey_id": ManttoData.id,
      "answers": answareData
    }
    
   
   
    // console.log(body)
    setLoadingM(true)
    const fetchDataPost = async () => {
        
     try {
       
          const response = await fetch(server.url+'/api/v1/cassia/surveys/_resolved_surveys/', {
            method: method,  
            headers: {
               "Accept": "application/json",
              // 'Content-Type': 'application/json',
              'Content-Type': 'application/json',
                Authorization: `Bearer ${localStorage.getItem('access_token')}`,
              },
            body:  JSON.stringify(body),
          });
        //  console.log(response)
          if (response.ok) {
            const data1 = await response.json();
            setLoadingM(false)
            closCreateCisModal()
            handleShowPopup(capitalizeFirstLetter(lang[languaje]['completado']),capitalizeFirstLetter((lang[languaje]['testGenCorr'])),'', true)

            // RegistrarPreguntas(data1.data.id)
            // setData(data1)

            // 
            // console.log(data1);
            // closCreateCisModal()
            // setRegisterIsValid(true)

            const timer = setTimeout(() => {
              // setRegisterIsValid(false)
              // setEditActive(false)
              // closCreateCisModal()
            }, 3000);
          } else {
            const data1 = await response.json();
            handleShowPopup('Error!!!',capitalizeFirstLetter(lang[languaje]['testInCorr']),data1.detail, false)
            throw new Error('Error en la solicitud');
          }
        } catch (error) {
            setHostName("")
            
            
        // setLoading(false)
          // Manejo de errores
          // setError(error)
          // closCreateCisModal()
          // setRegisterIsValid(true)
        //   handleShowPopup('Error!!!',capitalizeFirstLetter(lang[languaje]['regNoGenCorr']),capitalizeFirstLetter(lang[languaje]['reportError']), false)
          const timer = setTimeout(() => {
            // setRegisterIsValid(false)
            // setEditActive(false)
            // closCreateCisModal()
          }, 3000);
          console.error(error);
        }
      };
  
      fetchDataPost();
      
}
  const RegistrarPreguntas=(id)=>{
      
    let method='POST'
    let url_add=''
   
   
    OptionsData.forEach(question => {
      question.survey_id = id;
    });
    
   
   
    // console.log(body)
    // setLoading(true)
      const fetchDataPost = async () => {
        
     try {
       
          const response = await fetch(server.url+'/api/v1/cassia/surveys/_questions/'+url_add, {
            method: method,  
            headers: {
               "Accept": "application/json",
              // 'Content-Type': 'application/json',
              'Content-Type': 'application/json',
                Authorization: `Bearer ${localStorage.getItem('access_token')}`,
              },
            body: JSON.stringify(OptionsData),
          });
        //  console.log(response)
          if (response.ok) {
            const data1 = await response.json();
            // setData(data1)

            handleShowPopup(capitalizeFirstLetter(lang[languaje]['completado']),capitalizeFirstLetter(lang[languaje]['regGenCorr']),'', true)
            // console.log(data1);
            //   buscar_cis()
            closCreateCisModal()
            // setRegisterIsValid(true)

            const timer = setTimeout(() => {
              // setRegisterIsValid(false)
              // setEditActive(false)
              // closCreateCisModal()
            }, 3000);
          } else {
            const data1 = await response.json();
            handleShowPopup('Error!!!',capitalizeFirstLetter(lang[languaje]['regNoGenCorr']),data1.detail, false)
            throw new Error('Error en la solicitud');
          }
        } catch (error) {
            setHostName("")
            
            
        // setLoading(false)
        //   // Manejo de errores
        //   setError(error)
        //   closCreateCisModal()
        //   setRegisterIsValid(true)
        //   handleShowPopup('Error!!!',capitalizeFirstLetter(lang[languaje]['regNoGenCorr']),capitalizeFirstLetter(lang[languaje]['reportError']), false)
          const timer = setTimeout(() => {
            // setRegisterIsValid(false)
            // setEditActive(false)
            // closCreateCisModal()
          }, 3000);
          console.error(error);
        }
      };
  
      fetchDataPost();
      
}


  const [typeQuestion,setTypeQuestion]=useState(1)
  // console.log("tipo pregunta",typeQuestion)
  const changeTypeQuestion=(selected,element,index)=>{
      
      // console.log(selected,element,index)
      const updatedData = [...OptionsData];
  // Modificar el objeto en la posición indicada
  updatedData[index] = { ...updatedData[index], type: selected.type};
  // Actualizar el estado
  setOptionsData(updatedData);
          // setOptionsData((prevState)=>{
          //     return {
          //         ...prevState,
          //         ['trigger_id']:option.value===0?null:(parseInt(option.value))
          //     }
              
          // })
      
      
      // setManttoRelation(option.value)
          
  }
  const changeOption=(option,index)=>{
      
      // console.log(option)
     
      if(option.filter=="trigger"){
          setManttoData((prevState)=>{
              return {
                  ...prevState,
                  ['trigger_id']:option.value===0?null:(parseInt(option.value))
              }
              
          })
      }else if(option.filter=="period"){
          setManttoData((prevState)=>{
              return {
                  ...prevState,
                  ['period_id']:option.value===0?null:(parseInt(option.value))
              }
              
          })
      }else if(option.filter=="Estados"){
          setTypeQuestion(parseInt(option.value))
      }
      
      // setManttoRelation(option.value)
          
  }

  const [fecha, setDate] = useState('2023-09-28')

  const [resultList,setResultList]=useState([])


  //   console.log(resultList)

  const closeListSearch=()=>{
      setListSearchIP(false)
  }
  const addQuestion=()=>{
      const newOption = {
          survey_id: OptionsData.length + 1, // Genera un ID secuencial
          question_text: "",
          type: "Texto",
          options: []
        };
    
        // Agrega el nuevo objeto al final del arreglo
        setOptionsData(prevOptions => [...prevOptions, newOption]);
  }
  const addOptionToItem = (index) => {
      setOptionsData(prevOptions => {
        // Hacer una copia del arreglo actual
        const updatedOptions = [...prevOptions];
        
        // Agregar el nuevo valor a la propiedad options del objeto en la posición especificada
        updatedOptions[index] = {
          ...updatedOptions[index],
          options: [...updatedOptions[index].options, ""]
        };
        
        return updatedOptions;
      });
    };
  const removeOptionFromItem = (itemIndex, optionIndex) => {
    setOptionsData(prevOptions => {
      // Crear una copia del arreglo actual
      const updatedOptions = [...prevOptions];

      // Crear una copia del array options del objeto y eliminar la opción deseada
      const updatedItemOptions = [...updatedOptions[itemIndex].options];
      updatedItemOptions.splice(optionIndex, 1); // Eliminar la opción en la posición especificada

      // Actualizar el objeto con el nuevo array de opciones
      updatedOptions[itemIndex] = {
        ...updatedOptions[itemIndex],
        options: updatedItemOptions
      };

      return updatedOptions;
    });
  };
  const removeItem = (index) => {
    setOptionsData(prevOptions => {
      // Crear una copia del arreglo y eliminar el elemento en la posición especificada
      const updatedOptions = [...prevOptions];
      updatedOptions.splice(index, 1); // Eliminar el objeto en la posición `index`

      return updatedOptions;
    });
  };
  const handleChangeOptions = (e, index, optionIndex) => {
    const { value } = e.target;

    setOptionsData(prevOptions => {
      // Hacer una copia del arreglo actual
      const updatedOptions = [...prevOptions];

      // Crear una copia del objeto en el índice especificado
      const updatedItem = { ...updatedOptions[index] };

      // Crear una copia del array de opciones y actualizar la opción específica
      updatedItem.options = [...updatedItem.options];
      updatedItem.options[optionIndex] = value;

      // Reemplazar el objeto modificado en el arreglo principal
      updatedOptions[index] = updatedItem;

      return updatedOptions;
    });
  };

  const handleChangeRadio = (questionId, selectedOption) => {
    // const { value } = e.target;

    setAnswareData(prevOptions => {
      // Crear una copia del arreglo actual
      const updatedOptions = [...prevOptions];
      
      // Modificar el campo question_text del objeto en la posición especificada
      updatedOptions[questionId] = {
        ...updatedOptions[questionId],
        answer: selectedOption
      };
      
      return updatedOptions;
    });
  };
  const handleChangetext = (questionId, newValue) => {
    setAnswareData(prevAnswareData =>
      prevAnswareData.map(answer =>
        answer.question_id === questionId
          ? { ...answer, answer: newValue }
          : answer
      )
    );
  };
  const {code,title,description,trigger_id,period_id}=ManttoData;
  return(
      <div className="modal-GS-content">
          <div className='card-modal-gs modal-verificate'>
              <div className='head-card-modal-gs'>
                  <div className='title-head-card-modal-gs'>
                      {lang[languaje]['responder'].toUpperCase()+' '+lang[languaje]['encuesta'].toUpperCase()}
                  </div>
              </div>
              <div className='content-card-modal-gs' style={{overflowY: 'scroll',scrollbarWidth: 'thin',height:'95%'}}>
              
                                  <div className="form-GS-box" style={{height: '95%'}}> 
                                  
                                  
                                  
                                  <div className="user-box-GS"  style={{height:'13%'}}>
                                  
                                      <label className='label-GS  '>{capitalizeFirstLetter(lang[languaje]['titulo'])}</label>
                                      <div className='question-text'>
                                    {title}
                                    </div>
                                  </div>
                                  <div className="user-box-GS"  style={{height:'13%'}}>
                                  
                                      <label className='label-GS  '>{capitalizeFirstLetter(lang[languaje]['codigo'])}</label>
                                      <div className='question-text'>
                                    {code}
                                    </div>
                                  </div>
                                  <div className="user-box-GS"  style={{height:'13%'}}>
                                  
                                      <label className='label-GS  '>{capitalizeFirstLetter(lang[languaje]['descripcion'])}</label>
                                      <div className='question-text'>
                                    {description}
                                    </div>
                                  </div>
                                  
                                 
                                  <div className="user-box-GS "  style={{height:'5%'}}>
                                     
                                      <label className='label-GS'>{capitalizeFirstLetter(lang[languaje]['preguntas'])}</label>   
                                  </div>
                                  <div className='content-questions-gs'>
                                      {/*  */}
                                      {(loadingEncuesta || answareData.length!=OptionsData.length)?<LoadSimple></LoadSimple>:
                                        <>
                                          {
                                          OptionsData.map((element,index)=>(
                                              <div className='cont-row-question-gs'>
                                          <div className='compact-row-question-gs'>
                                              <div className='title-row-question-gs' style={{background:(answareData[index].answer=="")?'red':'var(--third-color)'}}>
                                                      {capitalizeFirstLetter(lang[languaje]['pregunta'])+" "+(index+1)}
                                                      
                                              </div>
                                              <div className='body-row-question-gs'>
                                              <div className="form-GS-box" style={{height:'auto',minHeight: '100px'}}> 
                                  
                                  
                                              <div className="user-box-GS"  style={{height:'20px'}}>
                                  
                                  </div>
                                  <div className="user-box-GS"  style={{height:'50px'}}>
                                    <div className='question-text'>
                                    {element.question_text}
                                    </div>
                                  {/* <input required name="question_text"  type="text" value={element.question_text}
                                   /> */}
                                      {/* <label className='label-GS  ' style={{top:'-15px'}}>{capitalizeFirstLetter(lang[languaje]['pregunta'])}</label>
                                       */}
                                  </div>
                                  {
                                    (element.type=="text")?
                                    <div className="user-box-GS "  style={{height:'50px'}}>
                                    
                                    <input required name="question_text"  type="text" value={ answareData.find(ans => ans.question_id === element.id)?.answer || ""} onChange={(e)=>handleChangetext(element.id, e.target.value)}
                                   /> 
                                </div>:''
                                  }
                                  {
                                      (element.type=="multiple")?
                                      <div className="user-box-GS "  style={{height:'50px',top:'15px'}}>
                                      
                                      <label className='label-GS'>{capitalizeFirstLetter(lang[languaje]['opciones'])}</label>   
                                  </div>:''
                                  }
                                  {
                                      (element.type=="multiple")?
                                      <>
                                      
                                      {element.options.map((textOption, optionIndex) => (
<div className="user-box-GS" style={{ height: '50px',justifyContent:'start' }} key={optionIndex}>
  <input
    type="radio"
    className='cyberpunk-checkbox'
    name={`option-${index}`} // Asegura que todos los radios del mismo grupo tengan el mismo nombre
    value={textOption}
    onChange={(e) => handleChangeRadio(index, textOption)}
    style={{width: '23px',
      borderRadius: '50%',
      height: '23'}}
  />
 
  <span>{textOption}</span> {/* Mostrar el texto de la opción */}
  
</div>
))}

                                      </>
                                      :''
                                  }
                                  </div> 
                                              </div>
                                          </div>
                                      </div>
                                          ))
                                      }
                                        </>
                                      }
                                      {/*  */}
                                  </div>
                                  
                              
                                 
                                  
                                  
                                  <div className="user-box-GS" style={{height:'33%'}}>
                                      {
                                          (loadingM)?<LoadSimple></LoadSimple>
                                          :
                                          <>
                                          <Action disabled={false} origen='Cancelar' titulo={capitalizeFirstLetter(lang[languaje]['cancelar'])}  action={closCreateCisModal}/>
                                          <Action disabled={(!answareData.every(item => item.answer.trim() !== ""))} origen='Azul' titulo={capitalizeFirstLetter(lang[languaje]['guardar'])}  action={RegistrarEncuesta}/>
                                          </>
                                          // <Action disabled={disabled} origen='Login' titulo='Guardar'  action={Registrar}/>
                                      }
                                          
                                  {
                                      // (registerIsValid && data.message!=="User deleted successfully")?<span className='form-msg-ok'>Usuario registrado correctamente</span>:''
                                  }
                                      
                                  </div>
                              </div>
              </div>
              </div>
      </div>
  )
}

export default ModalResponseEncuesta